var _circle, _rect, _path, _path2, _rect2, _rect3, _path3, _path4, _rect4, _rect5, _path5, _path6, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgEqualizeWorkload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5293,
    cy: 32,
    r: 32,
    fill: "#F0F3F9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.2539,
    y: 30.9805,
    width: 16.2963,
    height: 16.2963,
    fill: "#D8DDEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2539 30.9805H33.5502V32.8608H17.2539V30.9805Z",
    fill: "#F8F9FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2539 47.2773H33.5502V45.397H17.2539V47.2773Z",
    fill: "#C5CBDC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2383,
    y: 30.9805,
    width: 2.17284,
    height: 7.2428,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5508,
    y: 30.9805,
    width: 16.2963,
    height: 16.2963,
    fill: "#D8DDEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5508 30.9805H49.8471V32.8608H33.5508V30.9805Z",
    fill: "#F8F9FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5508 47.2773H49.8471V45.397H33.5508V47.2773Z",
    fill: "#C5CBDC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5312,
    y: 31,
    width: 2.17284,
    height: 7.2428,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2539,
    y: 14.6836,
    width: 16.2963,
    height: 16.2963,
    fill: "#D8DDEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2539 14.6836H33.5502V16.5639H17.2539V14.6836Z",
    fill: "#F8F9FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2539 30.9805H33.5502V29.1001H17.2539V30.9805Z",
    fill: "#C5CBDC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2383,
    y: 14.6836,
    width: 2.17284,
    height: 7.2428,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEqualizeWorkload);
export default __webpack_public_path__ + "static/media/img_equalize_workload.d14077f7ef4b0817297b413796ba698f.svg";
export { ForwardRef as ReactComponent };